import React from "react";
import { Player } from 'video-react';


const BookasessionNew = (props) => {
  var url = props.location.state;

  // Adding https to url if it doesnt exist
  if (!/^https?:\/\//i.test(url)) {
    url = 'https://' + url;
  }
     return (
        <div className="videoplayer mt-3 mt-md-0">
            <hr className="line"></hr>
            
            {/* <hr style={{lineHeight:"0"}}/> */}
            <div className="container pt-md-2">
                 <div className="card mx-auto weekly_date_card ">
                <Player autoPlay={true} className="player ml-4">
                <source src={url} />
                </Player>
                {/* <ReactPlayer
                    className='react-player'
                    url= {props.location.state}
                    playing= {play}
                    width='100%'
                    height='100%'
                    playIcon
                    onSeek={e => console.log('onSeek', e)}
                />
                <button onClick={() => setPlay(true)}>Play</button> <button onClick={()=>setPlay(false)}>Pause</button>
                <tr>
                <th>Seek</th>
                <td>
                  <input
                    type='range' min={0} max={0.999999} step='any'
                    value={played}
                    onMouseDown={handleSeekMouseDown}
                    onChange={handleSeekChange}
                    onMouseUp={handleSeekMouseUp}
                  />
                </td>
              </tr>  */}
                </div>
            </div>
        </div>
    );
};

export default BookasessionNew;